// components/ExpandableText.js
import React, { useMemo, useState } from "react";

// insert a zero-width space every `interval` chars to allow wrapping mid-word
const insertSoftBreaks = (str = "", interval = 30) =>
  !interval
    ? str
    : str
        .split("\n")
        .map(line => line.replace(new RegExp(`(.{${interval}})`, "g"), "$1\u200B"))
        .join("\n");

export default function ExpandableText({
  text = "",
  charLimit = 120,   // truncate threshold
  breakEvery = 28,   // force wrap opportunity every N chars
  className = "",
}) {
  const [expanded, setExpanded] = useState(false);
  const needsTruncate = (text || "").length > charLimit;
  const visible = expanded ? text : (text || "").slice(0, charLimit);
  const display = useMemo(() => insertSoftBreaks(visible, breakEvery), [visible, breakEvery]);

  if (!text) return null;

  return (
    <div className={className}>
      <span className={text.length>100?"break-text":""}>
        {display}
        {!expanded && needsTruncate ? "…" : ""}
      </span>
      {needsTruncate && (
        <button
          type="button"
          className="btn btn-link p-0 ms-2 align-baseline"
          onClick={() => setExpanded(v => !v)}
        >
          {expanded ? "View less" : "View more"}
        </button>
      )}
    </div>
  );
}
